import { render, staticRenderFns } from "./MiniImgSlider.vue?vue&type=template&id=352dbbd6"
import script from "./MiniImgSlider.vue?vue&type=script&lang=js"
export * from "./MiniImgSlider.vue?vue&type=script&lang=js"
import style0 from "./MiniImgSlider.vue?vue&type=style&index=0&id=352dbbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports